<template>
  <div id="pageRoot">
    <img id="bg" class="pageElement" src="/pages/img/sordoglo/svgGlo9bg.svg" />

    <span class="normalTheme pageInstruction" style="left: 87px; top: 75px">
      <p>Ordena las letras y escribe los nombres.</p>
    </span>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      defaultText="MOSCA"
      number="100"
      id="inputField01Disabled"
      disabled
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
    />

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField02"
      class="pageElement"
    />

    <img id="fly" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo7Fly.svg">
    <img id="duck" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo7Duck.svg">
    <img id="snail" class="pageElement basicItem01" src="/pages/img/sordoglo/svgGlo8Snail.svg">

  </div>
</template>
<style scoped>
#bg {
  position: absolute;
  left: 51px;
  top: 196px;
}
#inputField01Disabled{
  position: absolute;
  width: 432px;
  left: 300px;
  top: 224px;
}
#inputField01{
  position: absolute;
  width: 432px;
  left: 300px;
  top: 400px;
}
#inputField02{
  position: absolute;
  width: 432px;
  left: 300px;
  top: 574px;
}

#fly{
    position: absolute;
    left: 784px;
    top: 174px;
}
#duck{
    position: absolute;
    left: 784px;
    top: 340px;
}
#snail{
    position: absolute;
    left: 784px;
    top: 540px;
}
</style>
<script>
export default {
  data() {
    return {
      videos: ["glo/Video 28b.mp4", "glo/Video 29.mp4"]
    }
  }
}
</script>